import React, { FC } from "react";

import {
  useApisMembersAnalysisInsightPostsCountCalendarsIndex,
  usePrevNextSelectMonth,
} from "~/hooks";

import { ActivityOriginalCalendar } from "~/ui";

type PropsType = {
  className?: string;
};

export const InsightPostsCountCalendar: FC<PropsType> = ({
  className = "",
}: PropsType) => {
  const {
    targetDate,
    targetDateString,
    handlePrevMonthClick,
    handleNextMonthClick,
  } = usePrevNextSelectMonth();
  const { data, isLoading } =
    useApisMembersAnalysisInsightPostsCountCalendarsIndex({
      params: {
        targetDate: targetDateString,
      },
    });

  return (
    <ActivityOriginalCalendar
      isLoading={isLoading}
      dailyActivity={data?.insightPostsCalendar}
      targetDate={targetDate}
      onPrevMonthClick={handlePrevMonthClick}
      onNextMonthClick={handleNextMonthClick}
      isForRate={false}
      className={className}
    />
  );
};
